import { useParams, Outlet } from 'react-router-dom';
import EmptyShopSelection from './EmptyShopSelection';

// ----------------------------------------------------------------------

export default function ShopGuard() {
    const { shopid } = useParams();

    // Check if shopid is present and not 'undefined' string
    const hasShop = shopid && shopid !== 'undefined' && shopid !== 'null';

    if (!hasShop) {
        return <EmptyShopSelection />;
    }

    return <Outlet />;
}
